import { Box, Dialog, IconButton, Link, useTheme } from "@mui/material";
import { tokens } from "../../global/theme/tokens";
import Header from "../../components/special/Header";
import { useEffect, useState } from "react";
import { API_GET, DBRequest, useConfig } from "../../api/api";
import ExoTable from "../../components/exo/ExoTable";
import ExoAvatar from "../../components/exo/ExoAvatar";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import {
  ExoTableToolbar,
  ExoTableToolbarItem,
} from "../../components/exo/ExoTableToolbar";
import NewCompany from "../../components/new/NewCompany";

import LocalizedStrings from "react-localization";
import ContactSpeedDialMenu from "../../components/special/ContactSpeedDialMenu";
import ExtendCompany from "./ExtendCompany";
import updateViaId from "../../components/special/updateViaId";
import { useTranslation } from "react-i18next";
import MoneyLabel from "../../components/label/MoneyLabel";
import ExoDialog from "../../components/exo/ExoDialog";
import useFetch from "../../api/useFetch";
import { useNavigate } from "react-router-dom";
import { ExoAiOriginAnchor } from '../../components/exo/ExoAiOriginChip';

const Companys = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { apiData, setApiData } = useFetch(`companies`);

  const columns = [
    {
      header: t("Nr"), // header of column
      key: "nr", // key of column in row-object
      thAlign: "left", // header text alignment
      tdAlign: "left", // cell text alignment
      sortable: true, // enable sort function for column
      width: "130px", // width of column
      hiddenMobile: true, // hides the column on mobile
      cell: ({ row }) => <Box className="monospace">{row.nr}</Box>, // custom xml for cells in the column. you get the row as object
    },
    {
      header: t("Company Name"), // header of column
      key: "nameShort", // key of column in row-object
      thAlign: "left", // header text alignment
      tdAlign: "left", // cell text alignment
      sortable: true, // enable sort function for column
      cell: ({ row }) => (
        <Box className="flex flex-row justify-start items-center gap-2">
          <ExoAiOriginAnchor record={row}>
            <ExoAvatar
              picture={row.logo && row.logo.thumbnailUrl}
              name={row.nameShort}
              size="35px"
              type="company"
            />
          </ExoAiOriginAnchor>
          {row.nameShort}
        </Box>
      ),
      onClick: (row) => navigate(`/companies/${row.id}`),
    },

    {
      header: t("Total Sales"), // header of column
      key: "salesTotal", // key of column in row-object
      thAlign: "right", // header text alignment
      tdAlign: "right", // cell text alignment
      sortable: true, // enable sort function for column
      width: "130px", // width of column
      hiddenMobile: true, // hides the column on mobile
      cell: ({ row }) => <MoneyLabel money={row.salesTotal} />,
    },
  ];

  // new Company
  const [open, setOpen] = useState(false);
  function handleNewCompany(response) {
    var newCompanies = apiData;
    newCompanies.data.unshift(response.data);
    setApiData(newCompanies);
  }

  function handleUpdatedCompany(updatedCompany) {
    const newCompanies = updateViaId(apiData.data, updatedCompany.data);
    setApiData({ ...apiData, data: newCompanies });
  }

  return (
    <>
      <Header
        title={t("Companies")}
        subtitle="Here you can find all companies."
      />

      <ExoTableToolbar>
        <ExoTableToolbarItem
          text={t("New Company")}
          icon={<AddBusinessIcon />}
          onClick={() => setOpen(true)}
        />
      </ExoTableToolbar>
      <ExoTable
        extendElement={({ row, onUpdate, onDelete }) => (
          <ExtendCompany row={row} onUpdate={onUpdate} onDelete={onDelete} />
        )}
        columns={columns}
        data={apiData}
        isLoading={Boolean(!apiData)}
      />
      <ExoDialog open={open} limitWidth>
        <NewCompany
          fullWidth
          onClose={() => setOpen(false)}
          onCreate={handleNewCompany}
          onUpdate={handleUpdatedCompany}
        />
      </ExoDialog>
    </>
  );
};

export default Companys;
